import React from "react"
import cx from "classnames"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderCenterContentProps = {
  children?: React.ReactNode
  className?: string
}

// =============================================================================
// Styles
// =============================================================================

const pageSecondaryHeaderCenterContentStyles = [
  "@container/center-content",
  // Span the second row until `@4xl/page-header`
  // Then occupy the middle column of the first row
  "row-start-3 col-span-full @4xl/page-header:row-start-1 @4xl/page-header:col-span-1 @4xl/page-header:col-start-2",
  "flex items-center justify-center"
]

// =============================================================================
// Component
// =============================================================================

/**
 * Generic container for the secondary page header's center cell.
 *
 * Compose with `PageSecondaryHeader.Tabs`, `PageSecondaryHeader.TabLinks`, or
 * `PageSecondaryHeader.Steps`, or custom center content.
 */
export function PageSecondaryHeaderCenterContent({
  children,
  className
}: PageSecondaryHeaderCenterContentProps) {
  return (
    <div
      className={cx(pageSecondaryHeaderCenterContentStyles, className)}
      data-slot="secondary-center-content"
    >
      {children}
    </div>
  )
}
